import React from "react";

function Image(props) {
  const {
    imageUi,
    imageStatic,
    imageSrc,
    imageAlt,
    imageWidth,
    imageHeight,
    className,
  } = props;
  return (
    <img
      src={
        imageStatic
          ? process.env.REACT_APP_CDN +
            global.data().alias +
            "/static/" +
            imageSrc
          : imageUi
            ? process.env.REACT_APP_CDN +
              global.data().alias +
              "/ui/" +
              imageSrc
            : process.env.REACT_APP_CDN + imageSrc
      }
      alt={imageAlt}
      width={imageWidth ? imageWidth : null}
      height={imageHeight ? imageHeight : null}
      className={className ? className : null}
    />
  );
}

export default Image;
